import { render, staticRenderFns } from "./Video_index.vue?vue&type=template&id=1efdfc31&scoped=true"
import script from "./Video_index.vue?vue&type=script&lang=js"
export * from "./Video_index.vue?vue&type=script&lang=js"
import style0 from "./Video_index.vue?vue&type=style&index=0&id=1efdfc31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efdfc31",
  null
  
)

export default component.exports